import { createLogic } from 'redux-logic'
import handleErrors from '@app/helpers/handleErrors'
import { SYNC_COUNTERS_STATUS } from '@app/constants/syncCounters/countersStatus'
import { update } from '@app/actions/syncCounters/countersStatus'
import { closeSyncErrorPopup, syncChannel } from '@app/actions/syncCounters/countersChannel'
import Api from '@app/api/syncCounters/syncCountersStatus'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { apiRequestSent, apiRequestDone, apiRequestFailed } from '@app/actions/apiRequest'

const syncCountersStatusLogic = createLogic({
  type: SYNC_COUNTERS_STATUS,
  cancelType: API_REQUEST_CANCEL,

  process(_, dispatch, done) {
    const { secrets: { accessToken: { token } } } = store.getState()
    dispatch(apiRequestSent(SYNC_COUNTERS_STATUS))
    dispatch(closeSyncErrorPopup())
    Api.syncCountersStatus(token)
      .then((response) => {
        const { data } = response
        dispatch(update(data.sync_counters))
        dispatch(apiRequestDone(SYNC_COUNTERS_STATUS))
        dispatch(syncChannel())
      })
      .catch((error) => {
        if (error) {
          const currentError = handleErrors(error)
          dispatch(apiRequestFailed(currentError))
        } else {
          throw new Error('syncCountersStatus failed without error')
        }
      })
      .then(() => done())
  },
})

export default syncCountersStatusLogic
